module.exports = {
  title: 'Everybody can cook',
  author: 'Enzo Manuel Mangano',
  date: '2025-01-07',
  slug: 'everybody-can-cook',
  tags: ['reanimated'],
};
